const $ = <T extends HTMLElement>(selector: string) => {
  const element = document.querySelector<T>(selector);
  if (!element) {
    throw new Error(`Missing element: ${selector}`);
  }
  return element;
};

export const elements = {
  addSubtitleButton: $<HTMLButtonElement>('#addSubtitleButton'),
  advancedControls: $('#advancedControls'),
  audioInput: $<HTMLInputElement>('#audioInput'),
  clearImageButton: $<HTMLButtonElement>('#clearImageButton'),
  draftCustomizeButton: $<HTMLButtonElement>('#draftCustomizeButton'),
  draftDownloadLink: $<HTMLAnchorElement>('#draftDownloadLink'),
  draftEditSettingsButton: $<HTMLButtonElement>('#draftEditSettingsButton'),
  draftIdeaExampleButtons: Array.from(document.querySelectorAll<HTMLButtonElement>('[data-draft-idea]')),
  draftIdeaErrorMessage: $('#draftIdeaErrorMessage'),
  draftEmptyOutput: $('#draftEmptyOutput'),
  draftGenerateButton: $<HTMLButtonElement>('#draftGenerateButton'),
  draftIdeaForm: $<HTMLFormElement>('#draftIdeaForm'),
  draftIdeaInput: $<HTMLTextAreaElement>('#draftIdeaInput'),
  draftIdeaRecovery: $('#draftIdeaRecovery'),
  draftIdeaRetryButton: $<HTMLButtonElement>('#draftIdeaRetryButton'),
  draftIdeaValidation: $('#draftIdeaValidation'),
  draftOptionsForm: $<HTMLFormElement>('#draftOptionsForm'),
  draftOptionsStatus: $('#draftOptionsStatus'),
  draftOptionsStatusMessage: $('#draftOptionsStatusMessage'),
  draftProgress: $('#draftProgress'),
  draftResetButton: $<HTMLButtonElement>('#draftResetButton'),
  draftScriptCopyButton: $<HTMLButtonElement>('#draftScriptCopyButton'),
  draftRegenerateButton: $<HTMLButtonElement>('#draftRegenerateButton'),
  draftAngleTone: $('#draftAngleTone'),
  draftScriptInput: $<HTMLTextAreaElement>('#draftScriptInput'),
  draftScriptPanel: $('#draftScriptPanel'),
  draftScriptRecovery: $('#draftScriptRecovery'),
  draftScriptErrorMessage: $('#draftScriptErrorMessage'),
  draftScriptRefreshing: $('#draftScriptRefreshing'),
  draftScriptRetryButton: $<HTMLButtonElement>('#draftScriptRetryButton'),
  draftScriptTitle: $('#draftScriptTitle'),
  draftScriptWorkspace: $('#draftScriptWorkspace'),
  draftUseRecommendationsButton: $<HTMLButtonElement>('#draftUseRecommendationsButton'),
  draftReadTime: $('#draftReadTime'),
  draftWordCount: $('#draftWordCount'),
  draftWritingOutput: $('#draftWritingOutput'),
  draftWritingProgress: $('#draftWritingProgress'),
  draftWritingTitle: $('#draftWritingTitle'),
  draftWizardBackButton: $<HTMLButtonElement>('#draftWizardBackButton'),
  draftWorkflowButton: $<HTMLAnchorElement>('#draftWorkflowButton'),
  downloadLink: $<HTMLAnchorElement>('#downloadLink'),
  dropZone: $('#dropZone'),
  durationPill: $('#durationPill'),
  etaLabel: $('#etaLabel'),
  exportStats: $('#exportStats'),
  failureDetails: $<HTMLDetailsElement>('#failureDetails'),
  fileLabel: $('#fileLabel'),
  fullscreenDropZone: $('#fullscreenDropZone'),
  generateButton: $<HTMLButtonElement>('#generateButton'),
  homeWorkflowButton: $<HTMLAnchorElement>('#homeWorkflowButton'),
  homeDraftCustomizeButton: $<HTMLButtonElement>('#homeDraftCustomizeButton'),
  homeDraftIdeaExampleButtons: Array.from(document.querySelectorAll<HTMLButtonElement>('[data-home-draft-idea]')),
  homeDraftIdeaForm: $<HTMLFormElement>('#homeDraftIdeaForm'),
  homeDraftIdeaInput: $<HTMLTextAreaElement>('#homeDraftIdeaInput'),
  homeDraftIdeaValidation: $('#homeDraftIdeaValidation'),
  homeWorkspace: $('#homeWorkspace'),
  imageDropZone: $('#imageDropZone'),
  imagePlacementControls: $('#imagePlacementControls'),
  imageInput: $<HTMLInputElement>('#imageInput'),
  imageLabel: $('#imageLabel'),
  imageZoomSlider: $<HTMLInputElement>('#imageZoomSlider'),
  imageZoomValue: $('#imageZoomValue'),
  inputSize: $('#inputSize'),
  logOutput: $<HTMLPreElement>('#logOutput'),
  outputSize: $('#outputSize'),
  phaseLabel: $('#phaseLabel'),
  playOverlay: $<HTMLButtonElement>('#playOverlay'),
  previewFrame: $('#previewFrame'),
  progressBar: $('#progressBar'),
  progressLabel: $('#progressLabel'),
  progressShell: $('#progressShell'),
  progressTrack: $('#progressTrack'),
  qualitySlider: $<HTMLInputElement>('#qualitySlider'),
  qualityStat: $('#qualityStat'),
  renderReelWorkspace: $('#renderReelWorkspace'),
  renderWorkflowButton: $<HTMLAnchorElement>('#renderWorkflowButton'),
  resultVideo: $<HTMLVideoElement>('#resultVideo'),
  subtitleField: $('#subtitleField'),
  subtitleInput: $<HTMLInputElement>('#subtitleInput'),
  titleCanvas: $<HTMLCanvasElement>('#titleCanvas'),
  titleInput: $<HTMLInputElement>('#titleInput'),
};
